import { render, staticRenderFns } from "./MspLicenzaScaduta.vue?vue&type=template&id=64744d52"
import script from "./MspLicenzaScaduta.vue?vue&type=script&lang=js"
export * from "./MspLicenzaScaduta.vue?vue&type=script&lang=js"
import style0 from "./MspLicenzaScaduta.vue?vue&type=style&index=0&id=64744d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports